import { ICardListenerTabPrimary } from './types'
import css from './ui.tab.primary.module.scss'
import { isListenerMinor } from './listener-age'

import { SelectDate } from '@primitive/calendar'
import { getInputButton } from '@primitive/getInputButton'
import { DictSelectorContainer } from '@smart/dictSelector'
import { ListenerAddressInput } from '../listenerAddressInput'

import { IconUpdate } from '@img/icons'
import { Flex, Textarea, Input, Divider, Checkbox, Button, ToolTip } from '@ui/index'


/** Основная вкладка в анкете слушателя */
export const CardListenerTabPrimary = ({
    fieldsError, clientSnilsAuto, isAddressDisabled,
    txtCitizenshipID, txtCitizenship, txtSnils, txtClientPhone, txtClientEmail,
    txtLastName, txtFirstName, txtSecondName, txtBirthDate, txtFullNameFrom,
    txtPassport, txtAddress, txtEducationLevelID, txtEducationLevel, txtLastNameDiplom, txtDiplom,
    txtComment, txtSex,
    dictSelectorData, setTxtLastName, setTxtFirstName, setTxtSecondName,
    handleChangePhone, handlerSnilsAuto, handleChangeSnils, handlerPhoneGenerate,
}: ICardListenerTabPrimary) => {
    const isMinor = isListenerMinor(txtBirthDate.value)

    return <>
        <Flex gap="20px">
            <Flex gap="5px">
                <Divider prefix={<h4>Основная информация</h4>} />

                <Flex gap='15px'>
                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.citizenship ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Гражданство слушателя <p className='pulse'></p></Flex>
                            <Input placeholder="Гражданство слушателя" isReadOnly {...txtCitizenship} 
                                suffix={<>
                                    <DictSelectorContainer dictName="citizenship" 
                                        onSelect={(data) => { dictSelectorData('citizenship', data) }}
                                    >{getInputButton('select')}</DictSelectorContainer>
                                </>}
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.snils ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">СНИЛС слушателя <p className='pulse'></p></Flex>
                            
                            <Input placeholder="СНИЛС слушателя" mask='999-999-999 99' isReadOnly={clientSnilsAuto.value}
                                value={txtSnils.value} onChange={(e) => handleChangeSnils(e.target.value)}
                                type={(txtCitizenshipID.value === 185 && !clientSnilsAuto.value) ? 'mask' : 'text'}
                                suffix={
                                    <ToolTip title={clientSnilsAuto.value ? 'Ввести СНИЛС вручную' : 'Сгенерировать СНИЛС'} placement="bottomRight">
                                        <Checkbox right='2px' checked={clientSnilsAuto.value} onChange={(e) => handlerSnilsAuto(e.target.checked)} />
                                    </ToolTip>
                                }
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.clientPhone ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Телефон слушателя <p className='pulse'></p></Flex>
                            
                            <Input placeholder="Телефон слушателя" 
                                value={txtClientPhone.value} onChange={(e) => handleChangePhone(e.target.value)}
                                suffix={
                                    <ToolTip title="Сгенерировать телефон" placement="bottomRight">
                                        <Button size="sm" variant="iconInput" onClick={handlerPhoneGenerate}>
                                            <IconUpdate width='18px' height='18px' />
                                        </Button>
                                    </ToolTip>
                                }
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.clientEmail ? 'input_error' : 'input_error input_error-active'}>
                            <Flex flexDirection="row" className="input_header">Email слушателя</Flex>
                            <Input placeholder="Email слушателя" {...txtClientEmail}
                                suffix={txtClientEmail.value && getInputButton('clear', txtClientEmail.reset)} 
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.birthDate ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className={`input_header ${css['birth_date_header']}`}>
                                <span>Дата рождения</span>
                                {isMinor && <span className={css['minor_warning']} role="status">(НЕ СОВЕРШЕННОЛЕТНИЙ)</span>}
                                <p className='pulse'></p>
                            </Flex>
                            <Input placeholder="Дата рождения" type='mask' mask='99.99.9999' {...txtBirthDate}
                                suffix={<>
                                    {txtBirthDate.value && getInputButton('clear', txtBirthDate.reset)}

                                    <SelectDate currentDate={txtBirthDate.value} onSelect={(date) => txtBirthDate.setValue(date)}>
                                        {getInputButton('calendar')}
                                    </SelectDate>
                                </>} 
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.lastName ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Фамилия слушателя <p className='pulse'></p></Flex>
                            <Input placeholder="Фамилия слушателя" 
                                value={txtLastName} onChange={(e) => setTxtLastName(e.target.value)}
                                suffix={txtLastName && getInputButton('clear', () => setTxtLastName(''))} 
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.firstName ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Имя слушателя <p className='pulse'></p></Flex>
                            <Input placeholder="Имя слушателя" 
                                value={txtFirstName} onChange={(e) => setTxtFirstName(e.target.value)}
                                suffix={txtFirstName && getInputButton('clear', () => setTxtFirstName(''))} 
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px'>
                            <Flex flexDirection="row" className="input_header">Отчество слушателя</Flex>
                            <Input placeholder="Отчество слушателя" 
                                value={txtSecondName} onChange={(e) => setTxtSecondName(e.target.value)}
                                suffix={txtSecondName && getInputButton('clear', () => setTxtSecondName(''))} 
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.fullNameFrom ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Ф.И.О. слушателя (от кого) <p className='pulse'></p></Flex>
                            <Input placeholder="Ф.И.О. слушателя (от кого)" {...txtFullNameFrom}
                                suffix={txtFullNameFrom.value && getInputButton('clear', txtFullNameFrom.reset)}  
                            />
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>

            <Flex gap="5px">
                <Divider gap='6px' prefix={<h4>Удостоверение личности</h4>} suffix={
                        <div className={!fieldsError.value.sex ? 'input_error' : 'input_error input_error-active'}>
                            <div className={css['sex_switcher']}>
                                <button
                                    id='toolTipSexM'
                                    type='button'
                                    aria-pressed={txtSex.value === 'Мужской'}
                                    className={`${css['sex_switcher_button']} ${txtSex.value === 'Мужской' ? css['sex_switcher_button_active'] : ''}`}
                                    onClick={() => txtSex.setValue('Мужской')}
                                >
                                    М
                                </button>

                                <button
                                    id='toolTipSexJ'
                                    type='button'
                                    aria-pressed={txtSex.value === 'Женский'}
                                    className={`${css['sex_switcher_button']} ${txtSex.value === 'Женский' ? css['sex_switcher_button_active'] : ''}`}
                                    onClick={() => txtSex.setValue('Женский')}
                                >
                                    Ж
                                </button>
                            </div>
                        </div>
                    }
                />

                <Flex gap='15px'>
                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap" className='input_error'>
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.passport ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Паспорт слушателя <p className='pulse'></p></Flex>
                            <Textarea placeholder="ВНИМАНИЕ! Сначала введите серию и номер документа." rows={5} 
                                value={txtPassport.value} onChange={(e) => txtPassport.setValue(e.target.value)}
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.address ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Адрес прописки слушателя <p className='pulse'></p></Flex>
                            <ListenerAddressInput value={txtAddress.value} onChange={txtAddress.setValue} isDisabled={isAddressDisabled} />
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>

            <Flex gap="5px">
                <Divider prefix={<h4>Документ об образовании</h4>} />

                <Flex gap='15px'>
                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.educationLevel ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Уровень образования слушателя <p className='pulse'></p></Flex>
                            <Input placeholder="Уровень образования слушателя" isReadOnly {...txtEducationLevel}
                                suffix={<>
                                    <DictSelectorContainer isScroll={false} isSearch={false} dictName="educationLevel" 
                                        onSelect={(data) => { dictSelectorData('educationLevel', data) }}
                                    >{getInputButton('select')}</DictSelectorContainer>
                                </>}
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px'>
                            <Flex flexDirection="row" className="input_header">Фамилия слушателя в дипломе</Flex>
                            <Input placeholder="Фамилия слушателя в дипломе" {...txtLastNameDiplom}
                                suffix={txtLastNameDiplom.value && getInputButton('clear', txtLastNameDiplom.reset)}
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap" isRendered={txtEducationLevelID.value !== 1}>
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.diplom ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Документ об образовании слушателя <p className='pulse'></p></Flex>
                            <Textarea placeholder="Документ об образовании слушателя" rows={5} value={txtDiplom.value} onChange={(e) => txtDiplom.setValue(e.target.value)} isDisabled={txtEducationLevelID.value === 1} />
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>

            <Flex gap="5px">
                <Divider prefix={<h4>Прочее</h4>} />

                <Flex gap='15px'>
                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px'>
                            <Flex flexDirection="row" className="input_header">Комментарий</Flex>
                            <Textarea placeholder="Комментарий" rows={5} value={txtComment.value} onChange={(e) => txtComment.setValue(e.target.value)} />
                        </Flex>
                    </Flex>

                </Flex>
            </Flex>
        </Flex>

        {/* <ToolTip anchorSelect="#tooltipBtnClear" content='Очистить' place="left" /> */}
        {/* <ToolTip anchorSelect="#tooltipBtnSelect" content='Выбрать' place="left" /> */}
        {/* <ToolTip anchorSelect="#toolTipSnils" place="right">При установке галочки, СНИЛС сгенерируется автоматически.<br/>При снятии галочки, СНИЛС надо будет ввести вручную.</ToolTip> */}
        {/* <ToolTip anchorSelect="#toolTipSexM" content='Мужской пол' place="top-end" /> */}
        {/* <ToolTip anchorSelect="#toolTipSexJ" content='Женский пол' place="bottom-end" /> */}
        {/* <ToolTip anchorSelect="#tooltipBtnPhone" content='Сгенерировать телефон' place="bottom-end" /> */}
    </>
}
